import React from "react";
import MenuManagementMenu from "../components/menu/admin/MenuManagementMenu";

const ManajemenMenuAkses = () => {
  return <MenuManagementMenu />;
};
export default ManajemenMenuAkses;
